import {ISpecification} from "@/models/specifications/SpecificationHelpers/ISpecification";
import {IShipmentStore} from "@/models/StoreModels";
import {CELL_SIZES} from "@/constants/orders";

export class StoreShipmentCellSizeIsCorrect implements ISpecification<IShipmentStore> {
  public IsSatisfiedBy(candidate: IShipmentStore): boolean {
    return candidate.cell_size === CELL_SIZES.SIZE_ID_LARGE ||
      candidate.cell_size === CELL_SIZES.SIZE_ID_MEDIUM ||
      candidate.cell_size === CELL_SIZES.SIZE_ID_SMALL;
  }
}

